import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileFeatureKey } from './profile-feature-key';
import { ProfileState } from './profile.state';

export const ProfileFeatureSelector =
  createFeatureSelector<ProfileState>(ProfileFeatureKey);
// Update Email
export const updateProfileDataSelector = createSelector(
  ProfileFeatureSelector,
  (state) => {
    return state.updateProfileData;
  }
);
// Update Password
export const updatePasswordSelector = createSelector(
  ProfileFeatureSelector,
  (state) => {
    return state.updatePassword;
  }
);
// Update Photo
export const updatePhotoSelector = createSelector(
  ProfileFeatureSelector,
  (state) => {
    return state.updatePhoto;
  }
);
/**
 * Update Email Selectors
 */
export const updateProfileDataSuccessSelector = createSelector(
  updateProfileDataSelector,
  (state) => {
    return state.data;
  }
);
export const updateProfileDataFailureSelector = createSelector(
  updateProfileDataSelector,
  (state) => {
    return state.failure;
  }
);
export const updateProfileDataLoadingSelector = createSelector(
  updateProfileDataSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Password Selectors
 */
export const updatePasswordSuccessSelector = createSelector(
  updatePasswordSelector,
  (state) => {
    return state.data;
  }
);
export const updatePasswordFailureSelector = createSelector(
  updatePasswordSelector,
  (state) => {
    return state.failure;
  }
);
export const updatePasswordLoadingSelector = createSelector(
  updatePasswordSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Photo Selectors
 */
export const updatePhotoSuccessSelector = createSelector(
  updatePhotoSelector,
  (state) => {
    return state.data;
  }
);
export const updatePhotoFailureSelector = createSelector(
  updatePhotoSelector,
  (state) => {
    return state.failure;
  }
);
export const updatePhotoLoadingSelector = createSelector(
  updatePhotoSelector,
  (state) => {
    return state.loading;
  }
);
